import produce from "immer";
import { IStoreState } from "../initialStoreState";
import { LoadState } from "../../constants/enums";
import {
  FETCH_REVENUE_REPORT_PROGRESS,
  FETCH_REVENUE_REPORT_SUCCESS,
  FETCH_REVENUE_REPORT_FAILED,
  FETCH_LOST_REVENUE_BY_REASON_PROGRESS,
  FETCH_LOST_REVENUE_BY_REASON_SUCCESS,
  FETCH_LOST_REVENUE_BY_REASON_FAILED,
  FETCH_PEAK_BOOKING_PROGRESS,
  FETCH_PEAK_BOOKING_SUCCESS,
  FETCH_PEAK_BOOKING_FAILED,
  FETCH_UPSELL_CONTRIBUTION_PROGRESS,
  FETCH_UPSELL_CONTRIBUTION_SUCCESS,
  FETCH_UPSELL_CONTRIBUTION_FAILED,
  FETCH_UPSELL_CONTRIBUTION_TYPE_PROGRESS,
  FETCH_UPSELL_CONTRIBUTION_TYPE_SUCCESS,
  FETCH_UPSELL_CONTRIBUTION_TYPE_FAILED,
  FETCH_OWNER_INSIGHTS_PROGRESS,
  FETCH_OWNER_INSIGHTS_SUCCESS,
  FETCH_OWNER_INSIGHTS_FAILED,
  FETCH_MARGIN_REPORT_PROGRESS,
  FETCH_MARGIN_REPORT_SUCCESS,
  FETCH_MARGIN_REPORT_FAILED,
  FETCH_OWNER_REPORT_SUMMARY_PROGRESS,
  FETCH_OWNER_REPORT_SUMMARY_SUCCESS,
  FETCH_OWNER_REPORT_SUMMARY_FAILED,
  FETCH_CANCELLATION_LIST_REPORT_PROGRESS,
  FETCH_CANCELLATION_LIST_REPORT_SUCCESS,
  FETCH_CANCELLATION_LIST_REPORT_FAILED,
  FETCH_GUEST_VISIT_LIST_REPORT_PROGRESS,
  FETCH_GUEST_VISIT_LIST_REPORT_SUCCESS,
  FETCH_GUEST_VISIT_LIST_REPORT_FAILED,
  FETCH_ONGOING_LIST_REPORT_PROGRESS,
  FETCH_ONGOING_LIST_REPORT_SUCCESS,
  FETCH_ONGOING_LIST_REPORT_FAILED,
  FETCH_CANCELLATION_REASON_LIST_REPORT_FAILED,
  FETCH_CANCELLATION_REASON_LIST_REPORT_SUCCESS,
  FETCH_CANCELLATION_REASON_LIST_REPORT_PROGRESS,
  FETCH_DAILY_SUMMARY_REPORT_PROGRESS,
  FETCH_DAILY_SUMMARY_REPORT_SUCCESS,
  FETCH_DAILY_SUMMARY_REPORT_FAILED,
  FETCH_WEEKLY_SUMMARY_REPORT_PROGRESS,
  FETCH_WEEKLY_SUMMARY_REPORT_SUCCESS,
  FETCH_WEEKLY_SUMMARY_REPORT_FAILED,
  FETCH_COUNT_CANCELLATION_GUEST_VISIT_LOST_REVENUE_PROGRESS,
  FETCH_COUNT_CANCELLATION_GUEST_VISIT_LOST_REVENUE_SUCCESS,
  FETCH_COUNT_CANCELLATION_GUEST_VISIT_LOST_REVENUE_FAILED,
  FETCH_WEEKLY_GUEST_EVENT_SUMMARY_PROGRESS,
  FETCH_WEEKLY_GUEST_EVENT_SUMMARY_SUCCESS,
  FETCH_CWEEKLY_GUEST_EVENT_SUMMARY_FAILED,

  // count of cancellation lost revenue
  FETCH_COUNT_OF_CANCELLATION_LOST_REVENUE_PROGRESS,
  FETCH_COUNT_OF_CANCELLATION_LOST_REVENUE_SUCCESS,
  FETCH_COUNT_OF_CANCELLATION_LOST_REVENUE_FAILED,
  FETCH_COUNT_OF_CANCELLATION_REASON_LIST_PROGRESS,
  FETCH_COUNT_OF_CANCELLATION_REASON_LIST_SUCCESS,
  FETCH_COUNT_OF_CANCELLATION_REASON_LIST_FAILED,
  FETCH_COUNT_OF_CANCELLATION_LIST_PROGRESS,
  FETCH_COUNT_OF_CANCELLATION_LIST_SUCCESS,
  FETCH_COUNT_OF_CANCELLATION_LIST_FAILED,

  // count of guest visit list
  FETCH_COUNT_OF_GUEST_VISIT_LIST_PROGRESS,
  FETCH_COUNT_OF_GUEST_VISIT_LIST_SUCCESS,
  FETCH_COUNT_OF_GUEST_VISIT_LIST_FAILED,
  FETCH_COUNT_OF_GUEST_VISIT_CHIPS_PROGRESS,
  FETCH_COUNT_OF_GUEST_VISIT_CHIPS_SUCCESS,
  FETCH_COUNT_OF_GUEST_VISIT_CHIPS_FAILED,

  // employee performance report
  FETCH_EMPLOYEE_PERFORMANCE_REPORT_PROGRESS,
  FETCH_EMPLOYEE_PERFORMANCE_REPORT_SUCCESS,
  FETCH_EMPLOYEE_PERFORMANCE_REPORT_FAILED,

  // Count of Ongoing More Than 15 Days Chips
  FETCH_COUNT_OF_ONGOING_MORE_THAN_15_DAYS_CHIPS_PROGRESS,
  FETCH_COUNT_OF_ONGOING_MORE_THAN_15_DAYS_CHIPS_SUCCESS,
  FETCH_COUNT_OF_ONGOING_MORE_THAN_15_DAYS_CHIPS_FAILED,

  // Count of Daily Summary Chips
  FETCH_COUNT_OF_DAILY_SUMMARY_CHIPS_PROGRESS,
  FETCH_COUNT_OF_DAILY_SUMMARY_CHIPS_SUCCESS,
  FETCH_COUNT_OF_DAILY_SUMMARY_CHIPS_FAILED,

  // Count of Weekly Summary Chips
  FETCH_COUNT_OF_WEEKLY_SUMMARY_CHIPS_PROGRESS,
  FETCH_COUNT_OF_WEEKLY_SUMMARY_CHIPS_SUCCESS,
  FETCH_COUNT_OF_WEEKLY_SUMMARY_CHIPS_FAILED,

  // Count of Employee Performance Report Chips
  FETCH_COUNT_OF_EMPLOYEE_PERFORMANCE_REPORT_CHIPS_PROGRESS,
  FETCH_COUNT_OF_EMPLOYEE_PERFORMANCE_REPORT_CHIPS_SUCCESS,
  FETCH_COUNT_OF_EMPLOYEE_PERFORMANCE_REPORT_CHIPS_FAILED,
  FETCH_COUNT_OF_ONGOING_AGING_PROGRESS,
  FETCH_COUNT_OF_ONGOING_AGING_SUCCESS,
  FETCH_COUNT_OF_ONGOING_AGING_FAILED,
  FETCH_VENUE_PERFORMANCE_OVERVIEW_PROGRESS,
  FETCH_VENUE_PERFORMANCE_OVERVIEW_SUCCESS,
  FETCH_VENUE_PERFORMANCE_OVERVIEW_FAILED,
  FETCH_EVENT_SUMMARY_PROGRESS,
  FETCH_EVENT_SUMMARY_SUCCESS,
  FETCH_EVENT_SUMMARY_FAILED,
  FETCH_EVENT_TYPE_REPORT_PROGRESS,
  FETCH_EVENT_TYPE_REPORT_SUCCESS,
  FETCH_EVENT_TYPE_REPORT_FAILED,
  FETCH_ROOM_REPORT_PROGRESS,
  FETCH_ROOM_REPORT_SUCCESS,
  FETCH_ROOM_REPORT_FAILED,
  FETCH_TODAY_FOLLOWUPS_LIST_PROGRESS,
  FETCH_TODAY_FOLLOWUPS_LIST_SUCCESS,
  FETCH_TODAY_FOLLOWUPS_LIST_FAILED,
  FETCH_TODAYS_CANCELLATION_LIST_PROGRESS,
  FETCH_TODAYS_CANCELLATION_LIST_SUCCESS,
  FETCH_TODAYS_CANCELLATION_LIST_FAILED,
} from "./ReportActions";
import { initialReportRevenue } from "./defaultState";
import { IReportRevenue } from "./Report.types";
import { ReportRevenueActions } from ".";

export const reportRevenueReducer = (
  state: IStoreState["reportRevenue"] = initialReportRevenue,
  action: ReportRevenueActions,
) => {
  return produce(state, (draftState: IReportRevenue) => {
    switch (action.type) {
      // Revenue Report
      case FETCH_REVENUE_REPORT_PROGRESS:
        draftState.revenueReport.loading = LoadState.InProgress;
        break;
      case FETCH_REVENUE_REPORT_SUCCESS:
        draftState.revenueReport.loading = LoadState.Loaded;
        draftState.revenueReport.data = action.payload;
        break;
      case FETCH_REVENUE_REPORT_FAILED:
        draftState.revenueReport.loading = LoadState.Failed;
        break;

      // Lost Revenue By Reason
      case FETCH_LOST_REVENUE_BY_REASON_PROGRESS:
        draftState.lostRevenue.loading = LoadState.InProgress;
        break;
      case FETCH_LOST_REVENUE_BY_REASON_SUCCESS:
        draftState.lostRevenue.loading = LoadState.Loaded;
        draftState.lostRevenue.data = action.payload;
        break;
      case FETCH_LOST_REVENUE_BY_REASON_FAILED:
        draftState.lostRevenue.loading = LoadState.Failed;
        break;

      // Peak Booking Month By Year
      case FETCH_PEAK_BOOKING_PROGRESS:
        draftState.peakBooking.loading = LoadState.InProgress;
        break;
      case FETCH_PEAK_BOOKING_SUCCESS:
        draftState.peakBooking.loading = LoadState.Loaded;
        draftState.peakBooking.data = action.payload;
        break;
      case FETCH_PEAK_BOOKING_FAILED:
        draftState.peakBooking.loading = LoadState.Failed;
        break;

      // Upsell Contribution
      case FETCH_UPSELL_CONTRIBUTION_PROGRESS:
        draftState.upsellContribution.loading = LoadState.InProgress;
        break;
      case FETCH_UPSELL_CONTRIBUTION_SUCCESS:
        draftState.upsellContribution.loading = LoadState.Loaded;
        draftState.upsellContribution.data = action.payload;
        break;
      case FETCH_UPSELL_CONTRIBUTION_FAILED:
        draftState.upsellContribution.loading = LoadState.Failed;
        break;

      // Upsell Contribution Type
      case FETCH_UPSELL_CONTRIBUTION_TYPE_PROGRESS:
        draftState.upsellContributionType.loading = LoadState.InProgress;
        break;
      case FETCH_UPSELL_CONTRIBUTION_TYPE_SUCCESS:
        draftState.upsellContributionType.loading = LoadState.Loaded;
        draftState.upsellContributionType.data = action.payload;
        break;
      case FETCH_UPSELL_CONTRIBUTION_TYPE_FAILED:
        draftState.upsellContributionType.loading = LoadState.Failed;
        break;

      // Owner Insights
      case FETCH_OWNER_INSIGHTS_PROGRESS:
        draftState.ownerInsights.loading = LoadState.InProgress;
        break;
      case FETCH_OWNER_INSIGHTS_SUCCESS:
        draftState.ownerInsights.loading = LoadState.Loaded;
        draftState.ownerInsights.data = action.payload;
        break;
      case FETCH_OWNER_INSIGHTS_FAILED:
        draftState.ownerInsights.loading = LoadState.Failed;
        break;

      // Margin Report
      case FETCH_MARGIN_REPORT_PROGRESS:
        draftState.marginReport.loading = LoadState.InProgress;
        break;
      case FETCH_MARGIN_REPORT_SUCCESS:
        draftState.marginReport.loading = LoadState.Loaded;
        draftState.marginReport.data = action.payload;
        break;
      case FETCH_MARGIN_REPORT_FAILED:
        draftState.marginReport.loading = LoadState.Failed;
        break;

      // Owner Summary

      case FETCH_OWNER_REPORT_SUMMARY_PROGRESS:
        draftState.ownerReportSummary.loading = LoadState.InProgress;
        break;
      case FETCH_OWNER_REPORT_SUMMARY_SUCCESS:
        draftState.ownerReportSummary.loading = LoadState.Loaded;
        draftState.ownerReportSummary.data = action.payload;
        break;
      case FETCH_OWNER_REPORT_SUMMARY_FAILED:
        draftState.ownerReportSummary.loading = LoadState.Failed;
        break;

      // Cancellation list

      case FETCH_CANCELLATION_LIST_REPORT_PROGRESS:
        draftState.cancellationListReport.loading = LoadState.InProgress;
        break;
      case FETCH_CANCELLATION_LIST_REPORT_SUCCESS:
        draftState.cancellationListReport.loading = LoadState.Loaded;
        draftState.cancellationListReport.data = action.payload;
        break;
      case FETCH_CANCELLATION_LIST_REPORT_FAILED:
        draftState.cancellationListReport.loading = LoadState.Failed;
        break;

      // Cancellation Reason list

      case FETCH_CANCELLATION_REASON_LIST_REPORT_PROGRESS:
        draftState.cancellationReasonListReport.loading = LoadState.InProgress;
        break;
      case FETCH_CANCELLATION_REASON_LIST_REPORT_SUCCESS:
        draftState.cancellationReasonListReport.loading = LoadState.Loaded;
        draftState.cancellationReasonListReport.data = action.payload;
        break;
      case FETCH_CANCELLATION_REASON_LIST_REPORT_FAILED:
        draftState.cancellationReasonListReport.loading = LoadState.Failed;
        break;

      // Guest Visit list

      case FETCH_GUEST_VISIT_LIST_REPORT_PROGRESS:
        draftState.guestVisitListReport.loading = LoadState.InProgress;
        break;
      case FETCH_GUEST_VISIT_LIST_REPORT_SUCCESS:
        draftState.guestVisitListReport.loading = LoadState.Loaded;
        draftState.guestVisitListReport.data = action.payload;
        break;
      case FETCH_GUEST_VISIT_LIST_REPORT_FAILED:
        draftState.guestVisitListReport.loading = LoadState.Failed;
        break;

      // Ongoing list

      case FETCH_ONGOING_LIST_REPORT_PROGRESS:
        draftState.ongoingListReport.loading = LoadState.InProgress;
        break;
      case FETCH_ONGOING_LIST_REPORT_SUCCESS:
        draftState.ongoingListReport.loading = LoadState.Loaded;
        draftState.ongoingListReport.data = action.payload.data;
        draftState.ongoingListReport.totalRecords = action.payload.totalRecords ?? 0;
        break;
      case FETCH_ONGOING_LIST_REPORT_FAILED:
        draftState.ongoingListReport.loading = LoadState.Failed;
        break;

      // Daily summary

      case FETCH_DAILY_SUMMARY_REPORT_PROGRESS:
        draftState.dailySummaryReport.loading = LoadState.InProgress;
        break;
      case FETCH_DAILY_SUMMARY_REPORT_SUCCESS:
        draftState.dailySummaryReport.loading = LoadState.Loaded;
        draftState.dailySummaryReport.data = action.payload.data;
        draftState.dailySummaryReport.totalRecords = action.payload.totalRecords ?? 0;
        break;
      case FETCH_DAILY_SUMMARY_REPORT_FAILED:
        draftState.dailySummaryReport.loading = LoadState.Failed;
        break;

      // Weekly summary

      case FETCH_WEEKLY_SUMMARY_REPORT_PROGRESS:
        draftState.weeklySummaryReport.loading = LoadState.InProgress;
        break;
      case FETCH_WEEKLY_SUMMARY_REPORT_SUCCESS:
        draftState.weeklySummaryReport.loading = LoadState.Loaded;
        draftState.weeklySummaryReport.data = action.payload.data;
        draftState.weeklySummaryReport.totalRecords = action.payload.totalRecords ?? 0;
        break;
      case FETCH_WEEKLY_SUMMARY_REPORT_FAILED:
        draftState.weeklySummaryReport.loading = LoadState.Failed;
        break;

      // count of Cancellation - Guest Visit - Lost Revenue

      case FETCH_COUNT_CANCELLATION_GUEST_VISIT_LOST_REVENUE_PROGRESS:
        draftState.countOfCancellationGuestListLostRevenue.loading =
          LoadState.InProgress;
        break;
      case FETCH_COUNT_CANCELLATION_GUEST_VISIT_LOST_REVENUE_SUCCESS:
        draftState.countOfCancellationGuestListLostRevenue.loading =
          LoadState.Loaded;
        draftState.countOfCancellationGuestListLostRevenue.data =
          action.payload;
        break;
      case FETCH_COUNT_CANCELLATION_GUEST_VISIT_LOST_REVENUE_FAILED:
        draftState.countOfCancellationGuestListLostRevenue.loading =
          LoadState.Failed;
        break;

      //   count of weekly guest and event summary

      case FETCH_WEEKLY_GUEST_EVENT_SUMMARY_PROGRESS:
        draftState.countOfWeeklyGuestEventSummary.loading =
          LoadState.InProgress;
        break;
      case FETCH_WEEKLY_GUEST_EVENT_SUMMARY_SUCCESS:
        draftState.countOfWeeklyGuestEventSummary.loading = LoadState.Loaded;
        draftState.countOfWeeklyGuestEventSummary.data = action.payload;
        break;
      case FETCH_CWEEKLY_GUEST_EVENT_SUMMARY_FAILED:
        draftState.countOfWeeklyGuestEventSummary.loading = LoadState.Failed;
        break;

      // count of cancellation lost revenue
      case FETCH_COUNT_OF_CANCELLATION_LOST_REVENUE_PROGRESS:
        draftState.countOfCancellationLostRevenue.loading =
          LoadState.InProgress;
        break;
      case FETCH_COUNT_OF_CANCELLATION_LOST_REVENUE_SUCCESS:
        draftState.countOfCancellationLostRevenue.loading = LoadState.Loaded;
        draftState.countOfCancellationLostRevenue.data = action.payload;
        break;
      case FETCH_COUNT_OF_CANCELLATION_LOST_REVENUE_FAILED:
        draftState.countOfCancellationLostRevenue.loading = LoadState.Failed;
        break;

      // count of cancellation reason list
      case FETCH_COUNT_OF_CANCELLATION_REASON_LIST_PROGRESS:
        draftState.countOfCancellationReasonList.loading = LoadState.InProgress;
        break;
      case FETCH_COUNT_OF_CANCELLATION_REASON_LIST_SUCCESS:
        draftState.countOfCancellationReasonList.loading = LoadState.Loaded;
        draftState.countOfCancellationReasonList.data = action.payload;
        break;
      case FETCH_COUNT_OF_CANCELLATION_REASON_LIST_FAILED:
        draftState.countOfCancellationReasonList.loading = LoadState.Failed;
        break;
      
      // Todays cancellation list
      case FETCH_TODAYS_CANCELLATION_LIST_PROGRESS:
        draftState.todaysCancellationList.loading = LoadState.InProgress;
        break;
      case FETCH_TODAYS_CANCELLATION_LIST_SUCCESS:
        draftState.todaysCancellationList.loading = LoadState.Loaded;
        draftState.todaysCancellationList.data = action.payload.data;
        draftState.todaysCancellationList.totalRecords = action.payload.totalRecords ?? 0;
        break;
      case FETCH_TODAYS_CANCELLATION_LIST_FAILED:
        draftState.todaysCancellationList.loading = LoadState.Failed;
        break;

      // count of cancellation list
      case FETCH_COUNT_OF_CANCELLATION_LIST_PROGRESS:
        draftState.countOfCancellationList.loading = LoadState.InProgress;
        break;
      case FETCH_COUNT_OF_CANCELLATION_LIST_SUCCESS:
        draftState.countOfCancellationList.loading = LoadState.Loaded;
        draftState.countOfCancellationList.data = action.payload.data;
        draftState.countOfCancellationList.totalRecords = action.payload.totalRecords ?? 0;
        break;
      case FETCH_COUNT_OF_CANCELLATION_LIST_FAILED:
        draftState.countOfCancellationList.loading = LoadState.Failed;
        break;

      // count of guest visit list
      case FETCH_COUNT_OF_GUEST_VISIT_LIST_PROGRESS:
        draftState.countOfGuestVisitList.loading = LoadState.InProgress;
        break;
      case FETCH_COUNT_OF_GUEST_VISIT_LIST_SUCCESS:
        draftState.countOfGuestVisitList.loading = LoadState.Loaded;
        draftState.countOfGuestVisitList.data = action.payload.data;
        draftState.countOfGuestVisitList.totalRecords = action.payload.totalRecords ?? 0;
        break;
      case FETCH_COUNT_OF_GUEST_VISIT_LIST_FAILED:
        draftState.countOfGuestVisitList.loading = LoadState.Failed;
        break;

      // count of guest visit chips
      case FETCH_COUNT_OF_GUEST_VISIT_CHIPS_PROGRESS:
        draftState.countOfGuestVisitChips.loading = LoadState.InProgress;
        break;
      case FETCH_COUNT_OF_GUEST_VISIT_CHIPS_SUCCESS:
        draftState.countOfGuestVisitChips.loading = LoadState.Loaded;
        draftState.countOfGuestVisitChips.data = action.payload;
        break;
      case FETCH_COUNT_OF_GUEST_VISIT_CHIPS_FAILED:
        draftState.countOfGuestVisitChips.loading = LoadState.Failed;
        break;

      // employee performance report
      case FETCH_EMPLOYEE_PERFORMANCE_REPORT_PROGRESS:
        draftState.employeePerformanceReport.loading = LoadState.InProgress;
        break;
      case FETCH_EMPLOYEE_PERFORMANCE_REPORT_SUCCESS:
        draftState.employeePerformanceReport.loading = LoadState.Loaded;
        draftState.employeePerformanceReport.data = action.payload.data;
        draftState.employeePerformanceReport.totalRecords = action.payload.totalRecords ?? 0;
        break;
      case FETCH_EMPLOYEE_PERFORMANCE_REPORT_FAILED:
        draftState.employeePerformanceReport.loading = LoadState.Failed;
        break;

      // Count of Ongoing More Than 15 Days Chips
      case FETCH_COUNT_OF_ONGOING_MORE_THAN_15_DAYS_CHIPS_PROGRESS:
        draftState.countOfOngoingMoreThan15DaysChips.loading = LoadState.InProgress;
        break;
      case FETCH_COUNT_OF_ONGOING_MORE_THAN_15_DAYS_CHIPS_SUCCESS:
        draftState.countOfOngoingMoreThan15DaysChips.loading = LoadState.Loaded;
        draftState.countOfOngoingMoreThan15DaysChips.data = action.payload;
        break;
      case FETCH_COUNT_OF_ONGOING_MORE_THAN_15_DAYS_CHIPS_FAILED:
        draftState.countOfOngoingMoreThan15DaysChips.loading = LoadState.Failed;
        break;

      // Count of Daily Summary Chips
      case FETCH_COUNT_OF_DAILY_SUMMARY_CHIPS_PROGRESS:
        draftState.countOfDailySummaryChips.loading = LoadState.InProgress;
        break;
      case FETCH_COUNT_OF_DAILY_SUMMARY_CHIPS_SUCCESS:
        draftState.countOfDailySummaryChips.loading = LoadState.Loaded;
        draftState.countOfDailySummaryChips.data = action.payload;
        break;
      case FETCH_COUNT_OF_DAILY_SUMMARY_CHIPS_FAILED:
        draftState.countOfDailySummaryChips.loading = LoadState.Failed;
        break;

      // Count of Weekly Summary Chips
      case FETCH_COUNT_OF_WEEKLY_SUMMARY_CHIPS_PROGRESS:
        draftState.countOfWeeklySummaryChips.loading = LoadState.InProgress;
        break;
      case FETCH_COUNT_OF_WEEKLY_SUMMARY_CHIPS_SUCCESS:
        draftState.countOfWeeklySummaryChips.loading = LoadState.Loaded;
        draftState.countOfWeeklySummaryChips.data = action.payload;
        break;
      case FETCH_COUNT_OF_WEEKLY_SUMMARY_CHIPS_FAILED:
        draftState.countOfWeeklySummaryChips.loading = LoadState.Failed;
        break;

      // Count of Employee Performance Report Chips
      case FETCH_COUNT_OF_EMPLOYEE_PERFORMANCE_REPORT_CHIPS_PROGRESS:
        draftState.countOfEmployeePerformanceReportChips.loading =
          LoadState.InProgress;
        break;
      case FETCH_COUNT_OF_EMPLOYEE_PERFORMANCE_REPORT_CHIPS_SUCCESS:
        draftState.countOfEmployeePerformanceReportChips.loading = LoadState.Loaded;
        draftState.countOfEmployeePerformanceReportChips.data = action.payload;
        break;
      case FETCH_COUNT_OF_EMPLOYEE_PERFORMANCE_REPORT_CHIPS_FAILED:
        draftState.countOfEmployeePerformanceReportChips.loading = LoadState.Failed;
        break;

      // Count of Ongoing Aging Chips
      case FETCH_COUNT_OF_ONGOING_AGING_PROGRESS:
        draftState.countOfOngoingAging.loading = LoadState.InProgress;
        break;
      case FETCH_COUNT_OF_ONGOING_AGING_SUCCESS:
        draftState.countOfOngoingAging.loading = LoadState.Loaded;
        draftState.countOfOngoingAging.data = action.payload;
        break;
      case FETCH_COUNT_OF_ONGOING_AGING_FAILED:
        draftState.countOfOngoingAging.loading = LoadState.Failed;
        break;

      // Venue Performance Overview
      case FETCH_VENUE_PERFORMANCE_OVERVIEW_PROGRESS:
        draftState.venuePerformanceOverview.loading = LoadState.InProgress;
        break;
      case FETCH_VENUE_PERFORMANCE_OVERVIEW_SUCCESS:
        draftState.venuePerformanceOverview.loading = LoadState.Loaded;
        draftState.venuePerformanceOverview.data = action.payload.data;
        draftState.venuePerformanceOverview.totalRecords = action.payload.totalRecords ?? 0;
        break;
      case FETCH_VENUE_PERFORMANCE_OVERVIEW_FAILED:
        draftState.venuePerformanceOverview.loading = LoadState.Failed;
        break;

      // Event Summary
      case FETCH_EVENT_SUMMARY_PROGRESS:
        draftState.eventSummary.loading = LoadState.InProgress;
        break;
      case FETCH_EVENT_SUMMARY_SUCCESS:
        draftState.eventSummary.loading = LoadState.Loaded;
        draftState.eventSummary.data = action.payload;
        break;
      case FETCH_EVENT_SUMMARY_FAILED:
        draftState.eventSummary.loading = LoadState.Failed;
        break;

      // Event Type Report
      case FETCH_EVENT_TYPE_REPORT_PROGRESS:
        draftState.eventTypeReport.loading = LoadState.InProgress;
        break;
      case FETCH_EVENT_TYPE_REPORT_SUCCESS:
        draftState.eventTypeReport.loading = LoadState.Loaded;
        draftState.eventTypeReport.data = action.payload.data;
        draftState.eventTypeReport.totalRecords = action.payload.totalRecords ?? 0;
        break;
      case FETCH_EVENT_TYPE_REPORT_FAILED:
        draftState.eventTypeReport.loading = LoadState.Failed;
        break;

      case FETCH_ROOM_REPORT_PROGRESS:
        draftState.roomReport.loading = LoadState.InProgress;
        break;
      case FETCH_ROOM_REPORT_SUCCESS:
        draftState.roomReport.loading = LoadState.Loaded;
        draftState.roomReport.data = action.payload;
        break;
      case FETCH_ROOM_REPORT_FAILED:
        draftState.roomReport.loading = LoadState.Failed;
        break;

      case FETCH_TODAY_FOLLOWUPS_LIST_PROGRESS:
        draftState.todayFollowupsList.loading = LoadState.InProgress;
        break;
      case FETCH_TODAY_FOLLOWUPS_LIST_SUCCESS:
        draftState.todayFollowupsList.loading = LoadState.Loaded;
        draftState.todayFollowupsList.data = action.payload;
        break;
      case FETCH_TODAY_FOLLOWUPS_LIST_FAILED:
        draftState.todayFollowupsList.loading = LoadState.Failed;
        break;
    }
  });
};
